
import { defineComponent } from 'vue'

import ActiveUserMixin from '~/mixins/activeUserMixin'
import AutoOnboardMixin from '~/mixins/autoOnboardMixin'

export default defineComponent({
  name: 'AutoOnboardingMenu',
  mixins: [ActiveUserMixin, AutoOnboardMixin],
  data() {
    return {
      isCollapsed: false,
      pollingInterval: {} as ReturnType<typeof setInterval>
    }
  },
  mounted() {
    this.$socket.$on('repo-onboarding-completed', () => {
      this.refetchEvents()
    })
    // refetch every 1 minute
    this.pollingInterval = setInterval(this.refetchEvents, 0.5 * 60 * 1000)
  },
  methods: {
    async refetchEvents(): Promise<void> {
      await this.fetchOnboardingEventList({
        login: this.activeOwner,
        provider: this.activeProvider,
        refetch: true
      })

      if (this.autoOnboardEvents.length === 0) {
        clearInterval(this.pollingInterval)
        this.$socket.$off('repo-onboarding-completed')
      }
    }
  },
  beforeDestroy(): void {
    clearInterval(this.pollingInterval)
    this.$socket.$off('repo-onboarding-completed')
  },

  computed: {
    openCount(): number {
      return this.sortedEvents.filter((event) => event.status === 'OPEN').length
    },
    pendingCount(): number {
      return this.sortedEvents.filter((event) => event.status === 'PEND').length
    },
    prText(): string {
      return this.activeProvider === 'gl' ? 'merge' : 'pull'
    },
    settingsLink(): string {
      return ['', 'orgs', this.activeProvider, this.activeOwner, 'settings', 'auto-onboard'].join(
        '/'
      )
    }
  }
})
